/**
 * Display-only rounding for leave balance values. Stored values remain decimal.
 */
export function roundLeaveDaysForDisplay(value, rounding = "full_day") {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";

  let rounded = n;
  switch (rounding) {
    case "half_day":
      rounded = Math.round(n * 2) / 2;
      break;
    case "quarter_day":
      rounded = Math.round(n * 4) / 4;
      break;
    case "none":
      return Number.isInteger(n) ? String(n) : n.toFixed(2);
    case "full_day":
    default:
      rounded = Math.round(n);
      break;
  }

  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}
